<!--婴幼儿管理-->
<template>
  <div class="root-container">
    <el-form ref="registerRef" label-width="120px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="patriarchPhone">
            <el-input readonly="" v-model="param.patriarchPhone" style="width: 270px" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生日:">
            <el-date-picker style="width: 270px" v-model="param.birthday" type="date" placeholder="选择日期"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="家长姓名:" prop="patriarchName">
            <el-input readonly="" v-model="param.patriarchName" style="width: 270px" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="性别:">
            <el-select v-model="param.gender" placeholder="请选择" style="width: 270px">
              <el-option v-for="item in genderOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="会员姓名:">
            <el-input style="width: 270px" v-model="param.name" placeholder=""></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="小名:">
            <el-input style="width: 270px" v-model="param.petName" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="密码:">
            <el-input style="width: 270px" v-model="param.passWord" placeholder=""></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <template v-if="type == 'B'">
        <el-row v-for="(v, index) in param.userBuyLevels" :key="v">
          <el-col :span="12">
            <el-form-item label="业务等级:">
              <el-select v-model="v.lessonsId" placeholder="请选择" style="width: 270px">
                <el-option v-for="item in storeLessonsList" :disabled="param.userBuyLevels
                  .map((mk) => {
                    return Number(mk.lessonsId);
                  })
                  .includes(item.storeLessonId)
                  ? true
                  : false
                  " :key="item.storeLessonId" :label="item.name" :value="item.storeLessonId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" style="display: flex;align-items: center;">
            <el-form-item label="确认等级:">
              <el-select v-model="v.level" placeholder="请选择" style="width: 150px">
                <el-option v-for="item in levelOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <i class="el-icon-circle-plus"
              style="font-size: 25px; margin-left: 15px;cursor: pointer;color: #409eff;  margin-bottom: 22px;"
              @click="clickAdd"></i>
            <i class="el-icon-remove" @click="clickDele(index)" style=" 
                  font-size: 25px;
                  cursor: pointer;
                  margin-left: 15px;
                  color: #409eff;
                  margin-bottom: 22px;
                "></i>
          </el-col>
        </el-row>
      </template>
      <el-form-item label="小区:" prop="areaAddress">
        <el-input readonly="" v-model="param.areaAddress" placeholder="请输入小区"></el-input>
      </el-form-item>
      <el-form-item label="备注:">
        <el-input type="textarea" :autosize="{ minRows: 4 }" placeholder="请输入内容" style="width: 665px"></el-input>
      </el-form-item>
      <!-- <el-form-item label="语音备注:">
        <div style="width: 665px">
          <soundRecording />
        </div>
      </el-form-item> -->

      <!--<el-form-item label="备注信息" >-->
      <!--<el-input  style="width: 200px" v-model="createParam.remarks" placeholder=""></el-input>-->
      <!--</el-form-item>-->
    </el-form>
    <div slot="footer" class="dialog-footer-1">
      <el-button @click="handleCancel">取消</el-button>
      <el-button type="primary" @click="handleUpdate()">保存</el-button>
    </div>
  </div>
</template>

<style></style>

<script>
import commonUtils from "../../../utils/commonUtils";
import { selectChild, updateChildInfo } from "../../../api/userChild";
import messageUtils from "../../../utils/messageUtils";
import soundRecording from "@/components/soundRecording";
import enumsUtil, {
  EUserBuyCardStatu,
  getLevelDes,
  ECardUseType,
  getEnumDesByV,
  EAllLevelOption,
  EAllLevelOptions
} from "../../../utils/enumsUtil";

export default {
  name: "UpdateChildInfo",
  props: {
    childId: Number,
    type: {
      type: String,
      default: "B", //A基础游会员列表 B亲子会员列表
    },
    storeLessonsList: Array
  },
  components: {
    soundRecording,
  },
  data() {
    return {
      rules: {},
      genderOptions: [
        {
          value: 0,
          label: "男",
        },
        {
          value: 1,
          label: "女",
        },
      ],

      param: {},

      sourceOptions: [
        { name: "自然到访(WI)" },
        { name: "电话咨询(CI)" },
        { name: "网络咨询(NI)" },
        { name: "Peferral转介绍" },
        { name: "PT带到访" },
        { name: "CO" },
        { name: "异业合作" },
      ],

      levelOption: EAllLevelOption(),
      levelOptions: EAllLevelOptions(),
    };
  },
  mounted() { },
  created() {
    this.initParam();
  },
  methods: {
    clickAdd() {
      this.param.userBuyLevels.push({
        lessonsId: '',
        level: '',
        childId: this.param.childId,
      })
    },
    clickDele(ind) {
      this.$delete(this.param.userBuyLevels, ind)
    },
    // 初始化参数
    initParam() {
      let param = {
        id: this.childId,
      };

      selectChild(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        this.param = {
          name: data.name,
          // level: data.level,
          // subTypeLevel: Number(data.subTypeLevel),
          petName: data.petName,
          birthday: data.birthday,
          gender: data.gender,
          patriarchName: data.patriarchName,
          patriarchPhone: data.patriarchPhone,
          areaAddress: data.areaAddress,
          childId: data.id,
          passWord: data.passWord,
          userId: data.userId,
          userBuyLevels: data.userBuyLevels.length == 0 ? [{
            lessonsId: '',
            level: '',
            childId: data.id,
          }] : data.userBuyLevels
        };
        console.log(this.param,'this.param=')
      });
    },
    handleCancel() {
      this.$emit("onBtnCancel");
    },
    handleUpdate() {
      let param = {
        id: this.childId,
        name: this.param.name,
        petName: this.param.petName,
        birthday: this.param.birthday,
        gender: this.param.gender,
        passWord: this.param.passWord,
        userId: this.param.userId,
        // level: this.param.level,
        // subTypeLevel: this.param.subTypeLevel,
        userBuyLevels: this.param.userBuyLevels
      };

      updateChildInfo(param).then((response) => {
        let data = response.data;
        if (commonUtils.isObjectNull(data)) {
          return;
        }
        if (data == true) {
          messageUtils.successMsg(this, response.message);
          this.$emit("handleUpdate");
        } else {
          messageUtils.errorMsg(this, response.message);
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/user-by-lesson-card/components/UpdateChildInfo.vue